import { wire } from 'hyperhtml/umd';
import { ROUTES, TITLES, DESCRIPTIONS } from './constants';
import { HOME_SIZES, MOVE_TYPES } from '../../constants';
import { when } from '../../utils';
import renderContent from './partials/content';
import renderCTAs from './partials/ctas';
import { getClientState } from './utils';
import { ANALYTICS_PROPERTIES } from './analytics';

const withState = fn => (_, { getState }) => fn(getState());

const routesConfig = Object.values(ROUTES).reduce((routes, route) => {
  const title = TITLES[route];
  const description = DESCRIPTIONS[route];

  return {
    ...routes,
    [route]: {
      path: route,
      components: {
        ['#title']: when(title, () => withState(title)),
        ['#description']: when(description, () => withState(description)),
        ['#content']: renderContent(route),
        ['#CTAs']: renderCTAs(route),
      },
      data: {
        analytics: {
          event: 'Landing',
          properties: ANALYTICS_PROPERTIES[route],
        },
      },
    },
  };
}, {});

const rootConfig = {
  '/': {
    components: {},
    redirects: [
      (_, { store }) =>
        // TODO: Deprecate landings for each moveType but intrastate?
        getClientState(store).then(
          ({ currentMove: { moveType, eligible } }) => {
            if (eligible === false) {
              return ROUTES.outOfServiceArea;
            }

            if (
              moveType === MOVE_TYPES.INTERSTATE.toLowerCase() ||
              moveType === MOVE_TYPES.INTRASTATE.toLowerCase()
            ) {
              return ROUTES.longDistance;
            }

            return ROUTES.local;
          }
        ),
    ],
  },
};

export default {
  ...rootConfig,
  ...routesConfig,
};
